"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = page;

var _constants = require("redux/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    list: [],
    detail: {}
};

function page() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.PageConstants.SET_PAGE_LIST:
            var buffer = action.result;
            buffer.sort(function (a, b) {
                return a.position - b.position;
            });
            return (0, _extends3.default)({}, state, {
                list: buffer
            });
        case _constants.PageConstants.PAGE_DETAIL_LOAD_REQUEST:
            return (0, _extends3.default)({}, state, {
                detail: {}
            });
        case _constants.PageConstants.PAGE_DETAIL_LOAD_SUCCES:
            return (0, _extends3.default)({}, state, {
                detail: action.result
            });
        case _constants.PageConstants.PAGE_DETAIL_LOAD_FAIL:
            return (0, _extends3.default)({}, state);

        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/page.js
// module id = 1906
// module chunks = 0